/* eslint react/prop-types:0 */
import React from 'react';

import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { CustomContentView } from '@confluence/custom-content-view/entry-points/CustomContentView';
import { MainLayout } from '@confluence/main-layout';
import { Screen } from '@confluence/screen';

export const CustomContentViewRoute = ({ name, params: { contentId, spaceKey } }) => {
	return (
		<Screen
			screenEvent={{
				name: 'customContentView',
				id: contentId,
			}}
			pageState={{
				spaceKey,
				contentId,
				routeName: name,
			}}
		>
			<MainLayout spaceKey={spaceKey} navView={CONTAINER_HOME_ID}>
				<CustomContentView spaceKey={spaceKey} contentId={contentId} />
			</MainLayout>
		</Screen>
	);
};
